import axios from "axios";

const BASE_URL = process.env.REACT_APP_NEWDAILY_API_BASE_URL;

const api = axios.create({
  baseURL: BASE_URL,
});

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

api.interceptors.response.use(
  async (response) => {
    await delay(0);
    return response;
  },
  async (error) => {
    const status = error.response?.status;
    const data = error.response?.data;

    console.error("Axios error:", {
      baseURL: error.config?.baseURL,
      url: error.config?.url,
      method: error.config?.method,
      status,
      data,
      code: error.code,
    });

    const detail =
      typeof data === "string"
        ? data
        : data != null
          ? JSON.stringify(data)
          : error.message || "Unknown error";

    return Promise.reject(
      new Error(`HTTP ${status ?? "ERROR"}: ${detail}`)
    );
  }
);

export async function getJson(path, params = {}) {
  // setTimeout(async() => {
  const res = await api.get(path, { params });
  return res.data;
  // }, 1000);
}

export async function postJson(path, body) {
  const res = await api.post(path, body);
  return res.data;
}

export async function postForm(path, formData) {
  const res = await api.post(path, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export default api;
